
import { defineComponent, PropType } from "vue";
import { AdvertisementSpots } from "@/store";

export default defineComponent({
  props: {
    spot: {
      type: undefined as unknown as PropType<AdvertisementSpots>,
      required: true,
    },
  },
});
